import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import MasterYourLoft from "./sections/MasterYourLoft";
import TheHellzEdge from "./sections/TheHellzEdge";
import SecretosHarineros from "./sections/SecretosHarineros";
import Expertisegrid from "./sections/Expertisegrid";
import VictoryMetrics from "./sections/VictoryMetrics";
import TheStudiosSoul from "./sections/TheStudiosSoul";
import TwoPerspectives from "./sections/TwoPerspectives";
import Valuesmetrics from "./sections/Valuesmetrics";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <MasterYourLoft />
      <TheHellzEdge />
      <SecretosHarineros />
      <Expertisegrid />
      <VictoryMetrics />
      <TheStudiosSoul />
      <TwoPerspectives />
      <Valuesmetrics />
      <Footer />
    </div>;
}